import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, XCircle, Clock } from "lucide-react";
import { brl } from "@/lib/api";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Shell = ({ children }) => (
  <div className="min-h-screen bg-onyx text-white flex flex-col items-center justify-center px-6 text-center" data-testid="payment-result-page">
    <div className="max-w-md w-full trt-card bg-white text-slate-800 p-8 space-y-4">{children}</div>
  </div>
);

export default function PaymentResult({ cancelled = false }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [st, setSt] = useState(cancelled ? "cancelled" : "checking");
  const [tx, setTx] = useState(null);

  useEffect(() => {
    if (cancelled || !sessionId) return undefined;
    let tries = 0, timer;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        setTx(data);
        if (data.payment_status === "paid") { setSt("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setSt("failed"); return; }
      } catch (e) { if (e.response?.status === 404) { setSt("failed"); return; } }
      if (++tries < 8) timer = setTimeout(poll, 2000); else setSt("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, cancelled]);

  if (st === "cancelled") return <Shell><XCircle className="w-14 h-14 text-slate-400 mx-auto" /><h1 className="text-xl font-extrabold">Pagamento cancelado</h1><p className="text-sm text-slate-500">Nenhum valor foi cobrado. Você pode usar o mesmo link para tentar novamente.</p></Shell>;
  if (st === "checking") return <Shell><Loader2 className="w-14 h-14 gold-text mx-auto animate-spin" /><h1 className="text-xl font-extrabold">Confirmando pagamento…</h1><p className="text-sm text-slate-500">Aguarde alguns segundos.</p></Shell>;
  if (st === "paid") return <Shell><CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto" /><h1 className="text-xl font-extrabold" data-testid="payment-success-title">Pagamento confirmado!</h1><p className="text-sm text-slate-600">Mensalidade de <b>{tx?.empresa_nome}</b>{tx?.amount ? <> — <b className="mono">{brl(tx.amount)}</b></> : null} recebida. A validade da sua empresa foi renovada automaticamente.</p></Shell>;
  if (st === "failed") return <Shell><XCircle className="w-14 h-14 text-red-500 mx-auto" /><h1 className="text-xl font-extrabold">Pagamento não concluído</h1><p className="text-sm text-slate-500">O link expirou ou o pagamento falhou. Solicite um novo link ao suporte TRT Crédito Rápido.</p></Shell>;
  return <Shell><Clock className="w-14 h-14 text-amber-500 mx-auto" /><h1 className="text-xl font-extrabold">Pagamento em processamento</h1><p className="text-sm text-slate-500">Ainda não recebemos a confirmação. Assim que o banco confirmar, sua validade será renovada automaticamente.</p></Shell>;
}
